<template>
    <div class="lni-c-form-control"
        :class="{
            'lni-c-form-control--required': required,
            'lni-c-form-control--inline': inline,
            'lni-c-form-control--custom-width': customWidth
        }"
    >
        <label :for="controlId" class="lni-c-form-control__label">{{ labelText }}</label>
        <slot />
        <select
            :id="controlId"
            class="lni-c-form-control__select"
            v-model="value"
            @change="handleErrorState"
            :required="required"
            >
            <option
                v-for="item in items"
                v-bind:key="item.value"
                :value="item.value"
            >
                {{ item.text }}
            </option>
        </select>
    </div>
</template>

<script>
import framework from '../../framework';
import cities from '../../../static/cities.json';

/**
*  The x-type-ahead component.
*  @module components/x-type-ahead
*/


/**
* This component represents an input that takes a list and provides type ahead
* functionality on it.
*/
export default {
    name: 'x-type-ahead',
    props: {
        dataLabelText: String,
    },
    mixins: [
        framework.mixins.abstractSingleValueInput,
    ],
    mounted() {
        this.initialize();
    },
    computed: {
        /**
        * The text for the label.
        * @returns {string} label text.
        */
        labelText() {
            return this.getAttribute('labelText', '');
        },
        /**
        * The placeholder for the input.
        * @returns {string} placeholder text.
        */
        items() {
            // eslint-disable-next-line arrow-body-style
            let options = cities.map((c) => {
                return {
                    text: c,
                    value: c,
                };
            });

            options.unshift({
                text: 'Select an option',
                value: '',
            });

            return options;
        },

    },
    methods: {
        /**
        * Handles the input event and sets the changed value onto the component's model.
        * @param {*} event the input event
        * @returns {void}
        */
        onInput(event) {
            this.value = event.target.value;
        },

        /**
         * Gets the error information off of the input element(s)
         * @returns {void}
         */
        getErrorStateOffInputs() {
            return this.getSimpleErrorStateOffInputs('select');
        },
        /**
         * Put the values onto the Html Inputs
         * @returns {void}
         */
        initializeHtmlInputs() {
            if (this.componentValue) {
                let el = this.$el.querySelector(`select`);
                el.value = this.componentValue;
            }
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import
"../../styles/settings";
</style>



// WEBPACK FOOTER //
// source/components/x-type-ahead/x-type-ahead.vue